import { Component, Inject, Input, LOCALE_ID, OnChanges, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { setupMyPortalSections } from '@carm/shared/constants/const-setup-my-portal-features';
import { BasePageComponent } from '@carm/_utils/base-page.component';
import { takeUntil } from 'rxjs/operators';
import { IMenu } from '../models/menu.model';

@Component({
    selector: 'carm-main-header-setup-my-portal',
    templateUrl: './main-header-setup-my-portal.component.html',
    styleUrls: ['./main-header-setup-my-portal.component.scss'],
})
export class MainHeaderSetupMyPortalComponent extends BasePageComponent implements OnChanges, OnInit {

    @Input() isMenuOpen: boolean;
    public setupPortalMenuIsOpen = false;
    public setupMenuItems: IMenu[];
    public isLangFrench: boolean = false;

    constructor(private router: Router, @Inject(LOCALE_ID) protected localeId: string) {
        super();
    }

    ngOnChanges() {
        this.setupPortalMenuIsOpen = this.isMenuOpen;
    }

    ngOnInit() {
        this.setupMenuItems = setupMyPortalSections;
        this.router
            .events
            .pipe(takeUntil(this.destroy$))
            .subscribe((event) => {
            if (event instanceof NavigationEnd ) {
              this.setupPortalMenuIsOpen = false;
            }
        });

        if(this.localeId === 'fr') {
          this.isLangFrench = true;
        }
    }

    toggleSetupPortalMenu() {
        this.setupPortalMenuIsOpen = !this.setupPortalMenuIsOpen;
    }
}
